<script setup lang="ts">
import type { PropType } from "vue";
import SkeletonElement from "@/components/generic/SkeletonElement/SkeletonElement.component.vue";
import { SkeletonVariant } from "@/components/generic/SkeletonElement/SkeletonElement.model";

defineProps({
  isClosed: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
});
</script>

<template>
  <div class="link-card">
    <div class="link-card--header">
      <SkeletonElement
        :variant="SkeletonVariant.Text"
        width="130px"
        box-height="18px"
      />
      <SkeletonElement
        v-if="!isClosed"
        :variant="SkeletonVariant.Badge"
        width="100px"
        box-height="18px"
      />
    </div>
    <div class="link-card--order-details">
      <SkeletonElement
        :variant="SkeletonVariant.Text"
        width="180px"
        box-height="20px"
        class="description-list--key"
      />
      <SkeletonElement
        :variant="SkeletonVariant.Text"
        width="150px"
        box-height="20px"
        class="description-list--key"
      />
    </div>
    <div class="link-card--delivery-details">
      <SkeletonElement v-if="isClosed" :variant="SkeletonVariant.Button" />
      <SkeletonElement
        v-else
        :variant="SkeletonVariant.Text"
        width="130px"
        box-height="24px"
      />
    </div>
  </div>
</template>
